/**
 * Kurzformen für Gehzeiten — sprachabhängig, aber ohne Haken.
 *
 * `formatWalkingTime` und `estimateTime` werden aus Klassen und Modulen
 * gerufen, die keinen React-Kontext haben (LocationService, routes.ts, die
 * Karten-Rückrufe). Ihnen die Sprache durchzureichen hieße, sie durch ein
 * Dutzend Signaturen zu fädeln. Für reine Formatierung ist der übliche Weg
 * eine gesetzte Voreinstellung — wie eine Locale: EINMAL beim Sprachwechsel
 * gesetzt, danach von überall gelesen.
 *
 * Vorher standen „Min." und „Std." fest im Code und erschienen deshalb in
 * JEDER Sprache — auf Englisch las man „1 Std. 18 Min." unter einer sonst
 * englischen Route (Nachtlauf 2026-08-11, gemessen an der gerenderten
 * Routenauswahl).
 */
type Kuerzel = { minuteShort: string; hourShort: string }

const VORGABE: Kuerzel = { minuteShort: 'Min.', hourShort: 'Std.' }
let aktiv: Kuerzel = VORGABE

/** Beim Sprachwechsel einmal setzen (siehe I18nProvider). */
export function setEinheitenKuerzel(kuerzel: Kuerzel): void {
  aktiv = kuerzel
}

/** Gehzeit in Minuten als „18 min" / „1 hr 18 min" der aktiven Sprache. */
export function formatiereGehzeit(minutenGesamt: number): string {
  const gesamt = Math.max(0, Math.round(minutenGesamt))
  const h = Math.floor(gesamt / 60)
  const m = gesamt % 60
  if (h === 0) return `${m} ${aktiv.minuteShort}`
  return m > 0 ? `${h} ${aktiv.hourShort} ${m} ${aktiv.minuteShort}` : `${h} ${aktiv.hourShort}`
}

/** Nur die Minuten-Kurzform (für Stellen, die selbst rechnen). */
export function minutenKuerzel(): string {
  return aktiv.minuteShort
}
